import { Injectable, inject } from '@angular/core';
import { jwtDecode } from 'jwt-decode';
import { JwtPayload } from '../models/jwt-payload.model';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private key = 'token';
  private preAuthKey = 'pre-auth-token';
  private entraToken = 'entra-token';
  private _router = inject(Router);

  getTokenEntra(): string | null {
    return localStorage.getItem(this.entraToken);
  }

  removeTokenEntra() {
    localStorage.removeItem(this.entraToken);
  }

  setTokenEntra(token: string) {
    localStorage.setItem(this.entraToken, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.key);
  }

  removeToken() {
    localStorage.removeItem(this.key);
  }

  setToken(token: string) {
    localStorage.setItem(this.key, token);
  }

  getPreAuthToken(): string | null {
    return localStorage.getItem(this.preAuthKey);
  }

  setPreAuthToken(token: string) {
    localStorage.setItem(this.preAuthKey, token);
  }

  removePreAuthToken() {
    localStorage.removeItem(this.preAuthKey);
  }

  /** Email carried by the pre-auth token, used when the navigation state is not available. */
  getPreAuthEmail(): string | null {
    const token = this.getPreAuthToken();
    if (!token) {
      return null;
    }

    try {
      const decoded = jwtDecode(token) as JwtPayload;
      return decoded.email ?? decoded.unique_name ?? null;
    } catch {
      return null;
    }
  }

  getJwtPayload() {
    const token = this.getToken();
    if (!token) return {} as JwtPayload;
    try {
      const decoded = jwtDecode(token) as JwtPayload;
      return decoded;
    } catch {
      this._router.navigateByUrl('/login');
      return {} as JwtPayload;
    }
  }

  hasPermission(permission: string) {
    const token = this.getJwtPayload();
    if (!token) {
      return false;
    }

    const permissions = Array.isArray(token.Permission) ? token.Permission : [token.Permission];
    return permissions.includes(permission);
  }

  getRole(role: string) { 
    const jwtPayload = this.getJwtPayload();
    const roles = Array.isArray(jwtPayload.Role) ? jwtPayload.Role : [jwtPayload.Role];
    return roles.includes(role);
  }

  isAdmin() {
    return this.getRole('Administrator') || this.getRole('Admin');
  }

  isContributor() {
    return this.getRole('Contributor');
  }
}
